import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import Cookies from 'js-cookie';

// Apply the saved theme before rendering the app
const applyTheme = (theme) => {
  // Remove any existing theme classes
  document.documentElement.classList.remove('dark');
  
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else if (theme === 'auto') {
    // Check system preference
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (systemPrefersDark) {
      document.documentElement.classList.add('dark');
    }
  }
  // Light mode is default, no class needed
};

// Get or set default theme
const savedTheme = Cookies.get('theme') || 'auto'; // Default to auto mode
applyTheme(savedTheme);
Cookies.set('theme', savedTheme, { expires: 365 });

// Listen for system theme changes when in auto mode
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
  const currentTheme = Cookies.get('theme') || 'auto';
  if (currentTheme === 'auto') {
    applyTheme('auto');
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();